export const ANT_MARK = 'internalMark';
